import type { useTranslations } from 'next-intl'

import { URLS } from '@/configs/urls'

export type HeaderMenuItem = {
  labelKey: Parameters<ReturnType<typeof useTranslations<'header'>>>[0]
  label?: string
  href: string
  disabled?: boolean
}

const BASE_HEADER_MENU_ITEMS: HeaderMenuItem[] = [
  { labelKey: 'menu.fans', href: URLS.FANS },
  { labelKey: 'menu.forClubs', href: URLS.FOR_CLUBS },
  { labelKey: 'menu.challenges', href: URLS.CHALLENGES },
  { labelKey: 'menu.leaderboard', href: URLS.LEADERBOARD },
  { labelKey: 'menu.news', href: URLS.NEWS }
]

export function getHeaderMenuItems(showForClubsNav: boolean): HeaderMenuItem[] {
  if (showForClubsNav) {
    return BASE_HEADER_MENU_ITEMS
  }
  return BASE_HEADER_MENU_ITEMS.filter(item => item.href !== URLS.FOR_CLUBS)
}
